import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { MaterialInput } from 'lib/forms/material_input';
import i18n from "lib/utility/i18n";
import { Button } from 'reactifi';

export default class QuestionAnswerModal extends React.Component {
  static propTypes = {
    onSave: PropTypes.func.isRequired,
    answerCount: PropTypes.integer
  };

  static defaultProps = {
    answerCount: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      oldAnswer: null,
      answer: null,
      position: null,
      showAnswerModal: false
    }

    this.close = this.close.bind(this)
    this.saveAnswer = this.saveAnswer.bind(this)
  }

  wrapperClass(val) {
    if(val !== null) { return "fg-line fg-populated" }
    return "fg-line"
  }

  close() {
    this.setState({ showAnswerModal: false, answer: null })
  }

  show(answer = null) {
    this.setState({ oldAnswer: answer, answer: JSON.parse(JSON.stringify(answer)), showAnswerModal: true })
  }

  determineAnswerPlurality(){
    let answers = this.refs.answer_text.getValue()
    return answers.split(',')
  }

  value() {
    let answerArray = this.determineAnswerPlurality()
    // Handle one answer at a time
    if (answerArray.length < 2)
      return {
        answer_text: this.refs.answer_text.getValue(),
        description: this.refs.description.getValue(),
        position: parseInt(this.refs.position.getValue(), 10) || this.props.answerCount + 1
      }
    // handle multiple answer input
    else {
      return answerArray.map((ans, index) => {
        return ({
          answer_text: ans,
          description: '',
          position: (this.props.answerCount + index + 1)
        })
      });
    }
  }

  saveAnswer() {
    this.props.onSave(this.value(), this.state.oldAnswer)
  }

  render() {
    let answer = this.state.answer || {};

    return (
      <Modal show={this.state.showAnswerModal} onHide={this.close}>
        <Modal.Header>
          <Modal.Title>{this.state.answer ? i18n.t("Edit Answer") : i18n.t("New Answer")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Add answers for the custom registration question: paste all your answers as comma separated values or add one answer at a time.</p>
          <MaterialInput
            label={i18n.t("Answer Text")} type="text" defaultValue={answer.answer_text}
            wrapperClassName={this.wrapperClass(answer.answer_text)} ref="answer_text"  />
          <MaterialInput
            label={i18n.t("Description")} type="text" defaultValue={answer.description}
            wrapperClassName={this.wrapperClass(answer.description)} ref="description" />
          <MaterialInput
            label={i18n.t("Position")} type="text" defaultValue={answer.position} hidden={true}
            wrapperClassName={this.wrapperClass(answer.position)} ref="position" />
        </Modal.Body>
        <Modal.Footer>
          <Button label={i18n.t("Close")} className="pull-left" style="secondary" onClick={this.close} />
          <Button label={i18n.t("Save")} className="pull-right" style="primary" onClick={this.saveAnswer} />
        </Modal.Footer>
      </Modal>
    )
  }
}
